<template>
  <div>
    <h2 class="title mb-4">クリエイティブ設定条件</h2>
    <v-layout column>
      <h3 class="subheading">クリエイティブ設定方法</h3>
      <v-radio-group v-model="form.campaign.creativeAttachTarget">
        <v-radio
          :value="Targets.CAMPAIGN"
          label="キャンペーン全体でクリエイティブを設定"
        />
        <v-switch
          ref="switchUseCreativeSchedule"
          @click.prevent.stop="onClick"
          :input-value="useCreativeSchedule"
          :disabled="!form.campaign.isCampaignCreative"
          class="schedule-switch"
          label="クリエイティブを期間ごとに設定する"
        />
        <div v-if="form.campaign.hasGeoMenuSetting">
          <v-radio
            :value="Targets.DELIVERY_GROUP"
            label="配信地点グループ別に設定"
          />
          <small class="red--text">
            ※
            地点別にクリエイティブを設定する場合、クリエイティブを期間ごとに設定することはできません。
          </small>
        </div>
      </v-radio-group>
    </v-layout>
  </div>
</template>

<script>
import { CreativeAttachTargets } from '@/models/CampaignOperation'

export default {
  name: 'CampaignModalPageCreativeCondition',
  props: {
    form: {
      type: Object,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
    maxStep: {
      type: Number,
      required: true,
    },
  },
  computed: {
    creativeAttachTarget() {
      return this.form.campaign.creativeAttachTarget
    },
    Targets() {
      return CreativeAttachTargets
    },
    errorMessage() {
      return ''
    },
    useCreativeSchedule: {
      get() {
        return this.form.campaign.useCreativeSchedule
      },
      set(boolean) {
        this.form.campaign.useCreativeSchedule = boolean
      },
    },
    isGeoMenuSetting() {
      return this.form.campaign.hasGeoMenuSetting
    },
  },
  watch: {
    async creativeAttachTarget(value) {
      if (
        this.maxStep > this.step &&
        value === this.Targets.DELIVERY_GROUP &&
        this.useCreativeSchedule
      ) {
        const message =
          'クリエイティブの紐付け先を変更すると、\nクリエイティブのスケジュール設定および、\nクリエイティブ設定がリセットされます。よろしいですか？'
        const result = await this.$deleteConfirm(message, {
          okText: 'リセット',
        })
        if (!result) {
          this.form.campaign.creativeAttachTarget = this.Targets.CAMPAIGN
          return
        }
        this.form.campaign.removeCreatives()
        if (this.isGeoMenuSetting) {
          this.form.campaign.menuSetting.removeDeliveryCreatives()
        }
        this.useCreativeSchedule = !this.useCreativeSchedule
      }
    },
  },
  methods: {
    async onClick(e) {
      e.stopPropagation()
      if (
        this.maxStep > this.step &&
        (this.useCreativeSchedule ||
          this.form.campaign.hasCreative ||
          (this.isGeoMenuSetting && this.form.campaign.menuSetting.hasCreative))
      ) {
        const message =
          '期間ごとの設定のステータスを変更すると\nクリエイティブ設定はリセットされます。'
        const result = await this.$deleteConfirm(message, {
          okText: 'リセット',
        })
        if (!result) {
          this.$refs.switchUseCreativeSchedule.internalValue = this.useCreativeSchedule
          return
        }
        this.form.campaign.removeCreatives()
        if (this.isGeoMenuSetting) {
          this.form.campaign.menuSetting.removeDeliveryCreatives()
        }
      }
      this.useCreativeSchedule = !this.useCreativeSchedule
    },
  },
}
</script>

<style>
.schedule-switch {
  margin: 0 0 0 20px;
  display: inline-block;
}
</style>
